import './CategorySelector.scss';
import template from './CategorySelector.vhtml';

export default {
	name: 'CategorySelector',
	template: template,
	// props: ['categories'],
	props: {
		categories: {
			type: Array,
			default: [],
		},
		preSelect: {
			type: Object,
			default: null,
		},
	},
	data: () => ({
		selectedCategory: null,
	}),
	methods: {
		select(category = null) {
			this.selectedCategory = category;

			this.$emit('select', category ? category.id : null);
		},
	},
	mounted() {
		this.selectedCategory = this.preSelect;
		this.$emit(
			'select',
			this.selectedCategory ? this.selectedCategory.id : null
		);
	},
};
